import axiosInstance from "../../../helpers/api";

export const getAllStudentChapters = (id) => {
  return axiosInstance.get(`/student/chapters/section/${id}`);
};

export const getStudentChapter = (id) => {
  return axiosInstance.get(`/student/chapters/${id}`);
};

export const getStudentChapters = (body) => {
  return axiosInstance.get("/students/chapters/active", body);
};
